<template>
    <svg
        class="tw-w-4 tw-h-4 tw-me-1"
        :class="starClass"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 22 20"
    >
        <defs v-if="type === 'half'">
            <linearGradient :id="gradientId">
                <stop offset="50%" stop-color="currentColor"/>
                <stop offset="50%" stop-color="#d6d6d6"/>
            </linearGradient>
        </defs>
        <path
            :fill="fillColor"
            d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"
        />
    </svg>
</template>

<script>
export default {
    name: 'StarIcon',
    props: {
        type: {
            type: String,
            required: true,
            validator: (value) => ['full', 'half', 'empty'].includes(value)
        },
        index: {
            type: Number,
            default: 0
        }
    },
    computed: {
        starClass() {
            return {
                'tw-text-stinging-yellow': this.type === 'full' || this.type === 'half',
                'tw-text-grey-100': this.type === 'empty'
            };
        },
        fillColor() {
            if (this.type === 'half') {
                return `url(#${this.gradientId})`;
            }
            return 'currentColor';
        },
        gradientId() {
            return `halfGrad${this.index}`;
        }
    }
};
</script>
